import { render, staticRenderFns } from "./DownSetting.vue?vue&type=template&id=5d2d36f6&scoped=true&"
import script from "./DownSetting.vue?vue&type=script&lang=js&"
export * from "./DownSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2d36f6",
  null
  
)

export default component.exports